import {
    RESET_GROUPS,
    GET_GROUPS,
    SET_GROUPS,
    API_ERROR,
    GET_GROUP,
    SET_GROUP,
  } from "./actionTypes";

  const initialState = {
    errorGroup: false,
    loadingGroup: false,
    dataGroup: null,
    successGroup: false,
  };
  
  const Group = (state = initialState, action) => {
    switch (action.type) {
      case RESET_GROUPS:
        state = initialState;
        break;
      case GET_GROUPS:
        state = {
          errorGroup: false,
          loadingGroup: true,
          dataGroup: null,
        };
        break;
      case SET_GROUPS:
        state = {
          errorGroup: false,
          loadingGroup: false,
          dataGroup: action.payload,
        };
        break;
      case GET_GROUP:
        state = {
          errorGroup: false,
          loadingGroup: true,
          dataGroup: action.payload,
        };
        break;
      case SET_GROUP:
        state = {
          errorGroup: false,
          loadingGroup: false,
          dataGroup: action.payload,
        };
        break;
      case API_ERROR:
        state = {
          ...state,
          errorGroup: action.payload,
          loadingGroup: false,
          dataGroup: null,
          successGroup: false,
        };
        break;
      default:
        // state = { ...state, errorGroup: false, loadingGroup: false };
        break;
    }
    return state;
  };
  
  export default Group;
  